import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { getBorder } from 'Components/utils';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { Tabs } from '@facet-wealth/design';
import TabContentPicker from './TabContentPicker';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    padding: theme.spacing(0, 1),
  },
  tabs: {},
  tabContent: {
    overflowY: 'auto',
    flexGrow: 1,
    flexBasis: 1,
    ...getBorder(theme, { top: true, color: theme.palette.facet.lightGray }),
  },
});

const TabbedContent = ({
  className,
  classes,
}) => {
  const { pageContentResource } = usePageContentContext();
  const tabCollection = pageContentResource.attr('tabs');
  const selectedResource = pageContentResource.attr('scenarios').resources().list().find(el => el.attr('isSelected') === 'true');
  const firstTabName = tabCollection.resources().head()?.attr('key');
  const [tabName, setTabName] = React.useState(firstTabName);

  return (
    <div
      className={classNames(classes.root, className)}
    >
      <Tabs.Horizontal
        onChange={(_event, tabValue) => {
          setTabName(tabValue);
        }}
        value={tabName}
        options={pageContentResource.attr('tabs').resources().list().map((tabResource) => {
          return ({
            value: tabResource.attr('key'),
            label: tabResource.attr('label'),
          });
        })}
      />
      <div
        className={classes.tabContent}
      >
        <TabContentPicker
          tabName={tabName}
          tabResource={tabCollection.resources().list().find((r) => r.attr('key') === tabName)}
          key={tabName + selectedResource?.id()}
        />
      </div>
    </div>
  );
};

TabbedContent.defaultProps = {
  className: '',
};

TabbedContent.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TabbedContent);
